import(/* webpackMode: "eager" */ "/opt/cal.com/apps/web/app/global-error.tsx");
